import "@fontsource/literata/400.css"
import "@fontsource/literata/600.css"
import "@fontsource/literata/700.css"
import "@fontsource/public-sans/400.css"
import "@fontsource/public-sans/400-italic.css"
import "@fontsource/public-sans/500.css"
import "@fontsource/public-sans/600.css"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"
import "vanilla-cookieconsent/dist/cookieconsent.css"
import "./src/styles/design-system.css"
import "./src/styles/content.css"
import "./src/styles/cookie-consent.css"
import { initCookieConsent } from "./src/privacy/cookie-consent"

export const onClientEntry = () => initCookieConsent()
